module.exports = __webpack_public_path__ + "sgby/img/caiwenji-s.6a102db.png";